import { FC, PropsWithChildren } from "react";
import styles from "./FormGrid.module.css";

type FormGridProps = PropsWithChildren<{
  columns?: number;
  label?: string;
  columnHeaders?: string[];
}>;

const FormGrid: FC<FormGridProps> = ({ label, columnHeaders, columns, children }) => {
  const style: React.CSSProperties | undefined =
    columns || (columnHeaders && columnHeaders.length > 1)
      ? {
          gridTemplateColumns: `repeat(${columnHeaders?.length ?? columns}, minmax(0, 1fr))`,
        }
      : undefined;
  return (
    <>
      {!!columnHeaders?.length && (
        <div className={styles.grid} style={style}>
          {label && <label className={styles.label}>{label}</label>}
          {columnHeaders?.map((x, i) => (
            <div className={styles["column-header"]} key={`h_${i}`}>
              {x}
            </div>
          ))}
        </div>
      )}

      <div className={styles.grid} style={style}>
        {children}
      </div>
    </>
  );
};

export default FormGrid;
